import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { Info } from "material-ui-icons";

const tabs = [
  { label: "My MedMeetings", url: "my" },
  { label: "All Other MedMeetings", url: "all" },
];

class StudyGroupUserWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
    };
  }

  render() {
    const { location } = this.props;

    const { isHovered } = this.state;

    return (
      <main style={{ minHeight: "auto" }}>
        <h4 className="groups-title">
          <div>WELCOME TO MEDMEETINGS</div>
          {/* <div style={{ position: "relative" }}>
            <Info
              onClick={() =>
                this.setState({ isHovered: !this.state.isHovered })
              }
              style={{ color: "#2d98de", fontSize: 32, cursor: "pointer" }}
            />
            {isHovered && (
              <div className="groups-info-hover">
                MedMeetings gives MedCafe members exclusive access to
                member-only meetings and resources. Click the ‘Request to Join’
                button to request to be added.
              </div>
            )}
          </div> */}
        </h4>
        <StudyGroupUserNavigation tabs={tabs} activeUrl={location.pathname} />
        {this.props.children}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupUserWrapper);

class StudyGroupUserNavigation extends Component {
  render() {
    const { tabs, activeUrl } = this.props;

    const getUrl = (url) => `/groups/${url}`;

    const isUrlActive = (url) => activeUrl.includes(url);

    return (
      <div className="group-navigation">
        {tabs.map(({ label, url }, idx) => (
          <Link
            className={`group_button groups-navigation-button ${
              isUrlActive(url) && "active"
            }`}
            to={getUrl(url)}
            key={idx}
          >
            {label}
          </Link>
        ))}
        <Link
          className={`group_button groups-navigation-button`}
          to="/groups/become-superhost"
        >
          Become A Superhost
        </Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/StudyGroups/StudyGroupUserWrapper.jsx